import { useState, useEffect, useRef } from "react";
import { GetMocktestQuestion } from "../../../Client/request";
import { useContext } from "react";
import PteAttemptContext from "../PteAttemptContext";

export const useWritingQuestion = (quest, onQuestionLoaded, cachedQuestionData = null) => {
  const attemptId = useContext(PteAttemptContext);
  const [questData, setQuestData] = useState(cachedQuestionData || null);
  const [loading, setLoading] = useState(!cachedQuestionData);
  const [disabled, setDisabled] = useState(!cachedQuestionData);
  const onQuestionLoadedRef = useRef(onQuestionLoaded);

  useEffect(() => {
    onQuestionLoadedRef.current = onQuestionLoaded;
  }, [onQuestionLoaded]);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      setDisabled(true);
      if (cachedQuestionData) {
        setQuestData(cachedQuestionData);
        setLoading(false);
        setDisabled(false);
        onQuestionLoadedRef.current?.();
        return;
      }

      setQuestData(null);
      GetMocktestQuestion(quest?.QuestionId, attemptId).then((res) => {
        if (res?.data) {
          setQuestData(res?.data);
          setLoading(false);
          setDisabled(false);
          onQuestionLoadedRef.current?.();
        } else {
          setLoading(false);
        }
      }).catch((error) => {
        console.error('Error fetching writing question:', error);
        setLoading(false);
      });
    }
  }, [quest, cachedQuestionData, attemptId]);

  return { questData, loading, disabled, setDisabled };
};
